import type { FC, ReactNode } from 'react'

import SectionHeading from '@/components/landing/section-heading'
import CommissionForm from '@/components/landing/commission-form'

const NEXT_STEPS = [
    {
        number: '01',
        title: 'A personal reply',
        copy: 'Your request goes straight to the atelier, and we answer by email to talk through the car and the look.'
    },
    {
        number: '02',
        title: 'Fitment mapping',
        copy: 'We confirm hub, brake and fender measurements so the diameter, width and offset are exact.'
    },
    {
        number: '03',
        title: 'Design and proposal',
        copy: 'You receive a proposal for your set, with the finish, engraving and specification laid out in full.'
    }
]

const CommissionSection: FC = (): ReactNode => {
    return (
        <section id='commission' className='relative overflow-hidden border-t border-white/5 bg-[#08090c] py-24 sm:py-32'>
            <div className='pointer-events-none absolute left-1/2 top-0 h-px w-3/4 -translate-x-1/2 bg-linear-to-r from-transparent via-gold/50 to-transparent' aria-hidden='true' />
            <div className='pointer-events-none absolute -right-32 bottom-0 size-[520px] rounded-full bg-gold/5 blur-3xl' aria-hidden='true' />

            <div className='relative mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20'>
                <div>
                    <SectionHeading
                        eyebrow='Commission'
                        title={(
                            <>
                                Experience
                                <br />
                                <span className='text-gold-metal'>the fitment.</span>
                            </>
                        )}
                        description='Tell us about your car and the stance you have in mind. Every set is made to order, so the conversation starts here.'
                    />

                    <ol className='mt-12 space-y-8'>
                        {NEXT_STEPS.map((step) => (
                            <li key={step.number} className='flex gap-5'>
                                <span className='flex size-10 shrink-0 items-center justify-center rounded-full border border-gold/40 font-heading text-xs font-bold text-gold'>
                                    {step.number}
                                </span>
                                <div>
                                    <h3 className='font-heading text-sm font-bold tracking-[0.12em] text-white'>
                                        {step.title.toUpperCase()}
                                    </h3>
                                    <p className='mt-2 text-sm leading-relaxed text-titanium-light'>
                                        {step.copy}
                                    </p>
                                </div>
                            </li>
                        ))}
                    </ol>
                </div>

                <CommissionForm />
            </div>
        </section>
    )
}

export default CommissionSection
